import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { VerificationImages } from '@app/models';

@Component({
  selector: 'app-verification-images-preview',
  templateUrl: './verification-images-preview.component.html',
  styleUrls: ['./verification-images-preview.component.scss'],
  standalone: false
})
export class VerificationImagesPreviewComponent {
  @Input() images: VerificationImages = {};

  showBackPictures = false;
  failedImages: string[] = [];

  constructor(public translateService: TranslateService) {}

  get hasBack(): boolean {
    return !!this.images?.back && !this.failedImages.includes(this.images.back);
  }

  hasImage(url?: string): boolean {
    return !!url && !this.failedImages.includes(url);
  }

  markAsFailed(url: string) {
    if (!url) return;

    if (!this.failedImages.includes(url)) {
      this.failedImages.push(url);
    }
  }
}
